"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const multi_valued_text_field_1 = require("../../../../../layouts/multi-valued-text-field");
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const themes_1 = require("../../../../../utils/themes");
const style_1 = tslib_1.__importDefault(require("../../../../../utils/style"));
const HoverTooltip_1 = require("../../../../../../maintenance/test-automation/step7/components/HoverTooltip");
function PreProcessingStep2(props) {
    const { setUpdatedColumnData, errorMessage, setErrorMessage, remainingColumnError, setRemainingColumnError } = props;
    const columns = react_redux_1.useSelector((state) => state.columnSelectionS22);
    const [columnData, setColumnData] = react_1.useState(columns);
    const projectData = react_redux_1.useSelector((state) => state.ProjectInfo);
    const styleLocal = style_1.default();
    react_1.useEffect(() => {
        console.log("####### step 2 fun", columnData);
        setUpdatedColumnData(columnData);
    }, [columnData, setUpdatedColumnData]);
    react_1.useEffect(() => {
        if (columnData.remainingColumns == 0) {
            setRemainingColumnError("");
        }
    }, [columnData]);
    const addColumns = (value, type) => {
        console.log(columnData);
        switch (type) {
            case "categorical":
                setColumnData((pre) => (Object.assign({}, pre, { selectedCategoricalColumns: value, remainingColumns: columnData.remainingColumns.filter((r) => r !== value[value.length - 1]) })));
                break;
            case "numerical":
                setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalColumns: value, remainingColumns: columnData.remainingColumns.filter((r) => r !== value[value.length - 1]) })));
                break;
            case "target":
                if (value.length === 1) {
                    setColumnData((pre) => (Object.assign({}, pre, { selectedTargetColumn: value, remainingColumns: columnData.remainingColumns.filter((r) => r !== value[value.length - 1]) })));
                }
                break;
            case "dateTime":
                if (value.length === 1) {
                    setColumnData((pre) => (Object.assign({}, pre, { selectedDateTime: value, remainingColumns: columnData.remainingColumns.filter((r) => r !== value[value.length - 1]) })));
                }
                break;
            case "index":
                if (value.length === 1) {
                    setColumnData((pre) => (Object.assign({}, pre, { selectedIndexColumns: value, remainingColumns: columnData.remainingColumns.filter((r) => r !== value[value.length - 1]) })));
                    setErrorMessage("");
                }
                break;
            case "drop":
                setColumnData((pre) => (Object.assign({}, pre, { selectedDropColumns: value, remainingColumns: columnData.remainingColumns.filter((r) => r !== value[value.length - 1]) })));
                break;
            default:
                break;
        }
    };
    const removeColumn = (index, type) => {
        switch (type) {
            case "categorical":
                const newC = [...columnData.selectedCategoricalColumns];
                newC.splice(index, 1);
                const newRC = [...columnData.remainingColumns];
                newRC.includes(columnData.selectedCategoricalColumns[index]) ===
                    false && newRC.push(columnData.selectedCategoricalColumns[index]);
                setColumnData((pre) => (Object.assign({}, pre, { selectedCategoricalColumns: newC, remainingColumns: newRC })));
                break;
            case "numerical":
                const newN = [...columnData.selectedNumericalColumns];
                newN.splice(index, 1);
                const newRN = [...columnData.remainingColumns];
                newRN.includes(columnData.selectedNumericalColumns[index]) === false &&
                    newRN.push(columnData.selectedNumericalColumns[index]);
                setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalColumns: newN, remainingColumns: newRN })));
                break;
            case "target":
                const newT = [...columnData.selectedTargetColumn];
                newT.splice(index, 1);
                const newRT = [...columnData.remainingColumns];
                newRT.includes(columnData.selectedTargetColumn[index]) === false &&
                    newRT.push(columnData.selectedTargetColumn[index]);
                setColumnData((pre) => (Object.assign({}, pre, { selectedTargetColumn: newT, remainingColumns: newRT })));
                break;
            case "dateTime":
                const newD = [...columnData.selectedDateTime];
                newD.splice(index, 1);
                const newRD = [...columnData.remainingColumns];
                newRD.includes(columnData.selectedDateTime[index]) === false &&
                    newRD.push(columnData.selectedDateTime[index]);
                setColumnData((pre) => (Object.assign({}, pre, { selectedDateTime: newD, remainingColumns: newRD })));
                break;
            case "index":
                const newInd = [...columnData.selectedIndexColumns];
                newInd.splice(index, 1);
                const newRInd = [...columnData.remainingColumns];
                newRInd.includes(columnData.selectedIndexColumns[index]) === false &&
                    newRInd.push(columnData.selectedIndexColumns[index]);
                setColumnData((pre) => (Object.assign({}, pre, { selectedIndexColumns: newInd, remainingColumns: newRInd })));
                break;
            case "drop":
                const newDrop = [...columnData.selectedDropColumns];
                newDrop.splice(index, 1);
                const newRDrop = [...columnData.remainingColumns];
                !newRDrop.includes(columnData.selectedDropColumns[index]) &&
                    newRDrop.push(columnData.selectedDropColumns[index]);
                setColumnData((pre) => (Object.assign({}, pre, { selectedDropColumns: newDrop, remainingColumns: newRDrop })));
                break;
            default:
                break;
        }
    };
    console.log("columnData", columnData);
    return (react_1.default.createElement(core_1.Grid, { container: true },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 8, lg: 8, style: { backgroundColor: "white", padding: "30px" } },
            react_1.default.createElement(core_1.Typography, { className: styleLocal.topicFont }, "Assign columns to your preferred datatypes."),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement(HoverTooltip_1.HoverTooltip, { title: "Columns assigned to this will be treated as categorical data." },
                react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont }, "Categorical"),
                react_1.default.createElement(multi_valued_text_field_1.MultiValuedTextField, { columns: columnData.selectedCategoricalColumns, existingColumns: columnData.remainingColumns, addColumns: (v) => addColumns(v, "categorical"), removeColumn: (i) => removeColumn(i, "categorical") })),
            react_1.default.createElement(HoverTooltip_1.HoverTooltip, { title: "Columns assigned to this will be treated as numerical data." },
                react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont }, "Numerical"),
                react_1.default.createElement(multi_valued_text_field_1.MultiValuedTextField, { columns: columnData.selectedNumericalColumns, existingColumns: columnData.remainingColumns, addColumns: (v) => addColumns(v, "numerical"), removeColumn: (i) => removeColumn(i, "numerical") })),
            projectData.problemtype !== "rca_ms" && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont }, "Target"),
                react_1.default.createElement(multi_valued_text_field_1.MultiValuedTextField, { columns: columnData.selectedTargetColumn ? columnData.selectedTargetColumn : [], existingColumns: columnData.remainingColumns, addColumns: (v) => addColumns(v, "target"), removeColumn: (i) => removeColumn(i, "target"), error: errorMessage !== "", helperText: errorMessage }))),
            projectData.problemtype !== "rca_ms" && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont }, "Date time"),
                react_1.default.createElement(multi_valued_text_field_1.MultiValuedTextField, { columns: columnData.selectedDateTime, existingColumns: columnData.remainingColumns, addColumns: (v) => addColumns(v, "dateTime"), removeColumn: (i) => removeColumn(i, "dateTime") }))),
            projectData.problemtype === "rca_ms" && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(HoverTooltip_1.HoverTooltip, { title: "Select the column containing timestamps (e.g., Date or Timestamp) to be used as the index." },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont }, "Index"),
                    react_1.default.createElement(multi_valued_text_field_1.MultiValuedTextField, { columns: columnData.selectedIndexColumns ? columnData.selectedIndexColumns : [], existingColumns: columnData.remainingColumns, addColumns: (v) => addColumns(v, "index"), removeColumn: (i) => removeColumn(i, "index"), error: errorMessage !== "", helperText: errorMessage })))),
            projectData.problemtype === "rca_ms" && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(HoverTooltip_1.HoverTooltip, { title: "List columns that should be excluded from the dataset; they will not be included in further processing." },
                    react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont }, "Drop Columns"),
                    react_1.default.createElement(multi_valued_text_field_1.MultiValuedTextField, { columns: columnData.selectedDropColumns ? columnData.selectedDropColumns : [], existingColumns: columnData.remainingColumns, addColumns: (v) => addColumns(v, "drop"), removeColumn: (i) => removeColumn(i, "drop") })))),
            react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont }, "Remaining columns"),
            react_1.default.createElement("div", { style: themes_1.remainingColumnDiv }, columnData.remainingColumns.map((r, j) => {
                return react_1.default.createElement(core_1.Chip, { label: r, key: j, style: themes_1.remaingColumnChip });
            })),
            remainingColumnError != "" && (react_1.default.createElement(core_1.Typography, { variant: "body2", color: "error", style: { marginLeft: 1, fontSize: 11 } }, remainingColumnError)),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }))));
}
exports.PreProcessingStep2 = PreProcessingStep2;
//# sourceMappingURL=pre-processing-step2.js.map